"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAnalytics = exports.reportPageView = void 0;
var analytics_action_types_1 = require("./analytics-action-types");
var reportPageView = function (payload) { return ({
    type: analytics_action_types_1.REPORT_PAGE_EVENT,
    payload: payload,
}); };
exports.reportPageView = reportPageView;
var initAnalytics = function (payload) { return ({
    type: analytics_action_types_1.INIT_ANALYTICS,
    payload: payload,
}); };
exports.initAnalytics = initAnalytics;
